// The brand this deployment shows, chosen at build time with REACT_APP_BRAND: its name and logo come from brands.json,
// its install manifest and icons from public/brands/<brand>/. craco.config.js refuses to build or start without a
// known brand, so there is no default here.
import brands from "./brands.json";

// The software itself, which every brand runs and which bills the gym's subscription.
export const PRODUCT = brands.optimusfitness;
export const PRODUCT_NAME = PRODUCT.name;

export const brand = brands[process.env.REACT_APP_BRAND];
